import { type EvalIssueType } from '@/client/types.gen'

import { type EvalScoreType } from './types'

export const EVAL_ISSUE_TYPE_TO_SCORE_TYPE: Record<EvalIssueType, EvalScoreType> = {
  hallucination: 'trustworthiness',
  search_failure: 'context_sufficiency',
  unhelpful: 'response_helpfulness',
  difficult_query: 'query_ease',
  ungrounded: 'response_groundedness',
} as const

export const EVAL_ISSUE_TYPE_LABELS = {
  hallucination: 'Hallucination',
  search_failure: 'Search failure',
  unhelpful: 'Unhelpful',
  difficult_query: 'Difficult query',
  ungrounded: 'Ungrounded',
} as const satisfies Record<EvalIssueType, string>

export const EVAL_ISSUE_TYPES = [
  'hallucination',
  'search_failure',
  'unhelpful',
  'difficult_query',
  'ungrounded',
] as const satisfies readonly EvalIssueType[]

export const QUERY_LOGS_PAGE_SIZE = 20
export const REMEDIATIONS_PAGE_SIZE = 20
export const DEFAULT_GRID_MIN_ROW_HEIGHT = 66
export const EVALS_GRID_MIN_ROW_HEIGHT = 100

// TODO: Reduce this once we have ability to filter-out guardrails in the backend
//   See: src/app/(authenticated)/projects/[projectId]/evaluations/page.tsx
export const GUARDRAILS_EVALS_PAGE_SIZE = 300

export const FILTER_ANY_LABEL = 'Any'
export const IMPACT_SCORE_LABEL = 'Severity'

export type RemediationType = 'expert_answer' | 'guidance' | 'expert_review'

export const REMEDIATION_TYPE_LABELS = {
  expert_answer: 'Expert Answer',
  expert_review: 'Expert Review',
  guidance: 'Expert Guidance',
} as const satisfies Partial<Record<RemediationType, string>>

export const REMEDIATION_DESCRIPTION = {
  expert_answer:
    'Adding this Expert Answer will ensure your AI responds exactly as written for all future matching queries.',
  guidance:
    'Provide instructions for your AI to consider when answering similar questions, including on tone, information-gaps, or tools to use.',
} as const satisfies Partial<Record<RemediationType, string>>

export const EVAL_TYPE_LABELS = {
  probabilistic: 'Semantic',
  deterministic: 'Deterministic',
} as const
